/* eslint-disable no-unused-vars */
import { withStyles } from '@material-ui/styles';
import { BooleanInput } from 'react-admin';
import React from 'react';
import PropTypes from 'prop-types';
import { getTextWidth } from '../../../services/util';

const Switcher = withStyles(theme => ({
  root: {
    width: props => Math.max(
      Math.max(
        getTextWidth(props.checkedLabel || '', 'normal 11px Open Sans'),
        getTextWidth(props.uncheckedLabel || '', 'normal 11px Open Sans'),
      ) + 40,
      50,
    ),
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '& + $track': {
      '&:after': {
        opacity: 0,
      },
      '&:before': {
        opacity: 1,
      },
    },
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
        border: 'none',
        '&:before': {
          opacity: 0,
        },
        '&:after': {
          opacity: 1,
        },
      },
    },
    '&$focusVisible $thumb': {
      color: theme.palette.primary.main,
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 20,
    height: 20,
    margin: 2,
    boxShadow: 'none',
  },
  track: {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.grey[300],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
    '&:after, &:before': {
      color: 'white',
      fontSize: '11px',
      position: 'absolute',
      top: '5px',
    },
    '&:after': {
      content: props => `'${props.checkedLabel || ''}'`,
      left: '16px',
    },
    '&:before': {
      content: props => `'${props.uncheckedLabel || ''}'`,
      right: '13px',
    },
  },
  checked: {
    transform: props => {
      const checkLabelWidth = getTextWidth(props.checkedLabel || '', 'normal 11px Open Sans');
      const uncheckLabelWidth = getTextWidth(props.uncheckedLabel || '', 'normal 11px Open Sans');
      return `translateX(calc(${Math.max(Math.max(checkLabelWidth, uncheckLabelWidth) + 40, 50)}px - 100%)) !important`;
    },
  },
  formGroup: {
    '&>[class*="MuiFormControlLabel"]': {
      marginLeft: 0,
    },
  },
  focusVisible: {},
}))(({
  classes, uncheckedLabel, checkedLabel, ...otherProps
}) => (
  <BooleanInput
    options={{
      classes: {
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      },
      focusVisibleClassName: classes.focusVisible,
      disableRipple: true,
    }}
    classes={{
      root: classes.formGroup,
    }}
    label={false}
    helperText={false}
    {...otherProps}
  />
));

Switcher.propTypes = {
  checkedLabel: PropTypes.string,
  uncheckedLabel: PropTypes.string,
};

Switcher.defaultProps = {
  checkedLabel: undefined,
  uncheckedLabel: undefined,
};

export default Switcher;
